import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';

@Component({
	selector: 'app-tab-container',
	templateUrl: './tab-container.component.html',
	styleUrls: ['./tab-container.component.scss']
})
export class TabContainerComponent implements OnInit, OnDestroy {
	@Input() tabs: { path: string; label: string }[] = [];
	activeTabIndex: number = 0;
	routerEvents$?: Subscription;

	constructor(
		private router: Router,
		private route: ActivatedRoute
	) {}

	ngOnInit(): void {
		this.setActiveTabIndex(this.router.url);

		this.routerEvents$ = this.router.events
			.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
			.subscribe((event: NavigationEnd) => {
				this.setActiveTabIndex(event.urlAfterRedirects);
			});
	}

	onTabChange(event: any) {
		const selectedTab = this.tabs[event.index];
		if (selectedTab) {
			this.router.navigate([selectedTab.path], { relativeTo: this.route });
		}
	}

	private setActiveTabIndex(url: string) {
		this.tabs.forEach((tab, index) => {
			if (url.endsWith(tab.path)) {
				this.activeTabIndex = index;
			}
		});
	}

	ngOnDestroy(): void {
		this.routerEvents$?.unsubscribe();
	}
}
